module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_14.b42886da.jpg";